import { httpPost, httpDownload, httpGet } from '../../../../utils/api.utils';
import { convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
import {
    getDebitorCatalogue,
    setDebitorCatalogueError,
    setDebitorCatalogueColSearchStr,
    sortDebitorCatalogueItems,
    setDebitorCataloguePageSize,
    setDebitorCatalogueFilter,
    applyDebitorCatalogueFilter,
    setDefaultDebitorCatalogue,
    getDebitorDetailbyId,
    debitorCatalogueModel,
    getDebitorCatalogueDropdownList,
    resetDebitorCatalogueForm,
    setDebitorCountryList,
    getDebitorCountryList,
    getDebitorSalesOrganizationList
} from '../../../../constants/model-reducers/external/recharge/debitor-catalogue.settings';
import { actions } from 'react-redux-form';
import { DEFAULT_TABLE_RESULT_DEBITOR_CATALOGUE_DROPDOWN_MODEL, DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../../constants/external-constants';

export const debitorCatalogueInitialState = debitorCatalogueModel

const defaultState = () => ({
    isDebitorCatalogueLoaded: false,
    isDebitorCatalogueError: false,
    debitorCatalogueItems: DEFAULT_TABLE_RESULT_MODEL,
    debitorCatalogueColSort: '',
    debitorCatalogueIsSortedAsc: true,
    debitorCatalogueTableFilterList: [],
    debitorCatalogueTableFilterApply: false,
    isDebitorCatalogueDropDownListLoaded: false,
    isDebitorCountryLoaded: false,
    isDebitorSalesOrganizationListLoaded: false,
    isFetchFormLoaded:false,
    isNew:true,
    countryList: [],
    salesOrganizationList: [],
    debitorCatalogueDetails: {
        debitorId: 0,
        debitorNumber: "",
        debitorName: "",
        oeName: "",
        countryId: 0,
        currencyId: 0,
        salesOrganizationId: 0,
        salesOrganizationName: "",
        salesOrganizationCountryCode: "",
        vatPercent: "0.00",
        vatGroupId: 0
    },
});
const initialState = defaultState();
export const debitorCatalogueActions = {
    setDefaultDebitorCatalogue: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultDebitorCatalogue,
            debitorCatalogueItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },

    getDebitorCatalogue: (pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().debitorCatalogue.debitorCatalogueItems;
        const { 
            debitorCatalogueIsSortedAsc, 
            debitorCatalogueColSort, 
            debitorCatalogueTableFilterList, 
            debitorCatalogueTableFilterApply } = state().debitorCatalogue;

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: sessionStorage.getItem('UserID'),
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: debitorCatalogueColSort,
                IsSortAscending: debitorCatalogueIsSortedAsc,
                TableFilterList: debitorCatalogueTableFilterList,
                ApplyFilter: debitorCatalogueTableFilterApply,
            };
            var debitorCatalogueItems = await httpPost('external/recharge/getDebitorCatalogueItems', data);

            if (debitorCatalogueItems?.Data?.Items?.length) {
                debitorCatalogueItems.Data.Items = debitorCatalogueItems.Data.Items.map(item => {
                    item.VatApplied = item.VatApplied != null
                        ? Number(item.VatApplied).toFixed(2)  // formats to string like "0.00"
                        : "0.00"; // fallback for null
            
                    return item;
                });
            }

            dispatch({
                type: getDebitorCatalogue,
                debitorCatalogueItems: Object.keys(debitorCatalogueItems).length > 0 ? debitorCatalogueItems : DEFAULT_TABLE_RESULT_MODEL,
                isDebitorCatalogueLoaded: true,
                isDebitorCatalogueError: false
            });
        }
        catch (e) {
            dispatch({
                type: setDebitorCatalogueError,
                isDebitorCatalogueError: true,
                isDebitorCatalogueLoaded: false
            });
        }
    },

    sortDebitorCatalogueItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().debitorCatalogue.debitorCatalogueItems.Pagination;
        const { debitorCatalogueItems, debitorCatalogueTableFilterList, debitorCatalogueTableFilterApply } = state().debitorCatalogue;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: debitorCatalogueItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...debitorCatalogueItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: debitorCatalogueTableFilterList,
            ApplyFilter: debitorCatalogueTableFilterApply,
        };
        var resDebitorCatalogueItems = await httpPost('external/recharge/getDebitorCatalogueItems', data);

        if (resDebitorCatalogueItems?.Data?.Items?.length) {
            resDebitorCatalogueItems.Data.Items = resDebitorCatalogueItems.Data.Items.map(item => {
                item.VatApplied = item.VatApplied != null
                    ? Number(item.VatApplied).toFixed(2)  // formats to string like "0.00"
                    : "0.00"; // fallback for null
        
                return item;
            });
        }

        if (resDebitorCatalogueItems.ok === false) {
            dispatch({
                type: setDebitorCatalogueError,
                isDebitorCatalogueError: true,
                isDebitorCatalogueLoaded: false
            });
        } else {
            dispatch({
                type: sortDebitorCatalogueItems,
                debitorCatalogueItems: Object.keys(resDebitorCatalogueItems).length > 0 ? resDebitorCatalogueItems : DEFAULT_TABLE_RESULT_MODEL,
                debitorCatalogueColSort: columnClicked,
                debitorCatalogueIsSortedAsc: isSortedAsc,
                isDebitorCatalogueLoaded: true,
            });
        }
    },

    setDebitorCatalogueColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { debitorCatalogueItems } = state().debitorCatalogue;
        var debitorCatalogueItemsUpd = {
            ...debitorCatalogueItems,
            "Headers": {
                ...debitorCatalogueItems.Headers,
                [key]: {
                    ...debitorCatalogueItems.Headers[key],
                    searchString: val
                }
            }
        }
        dispatch({
            type: setDebitorCatalogueColSearchStr,
            data: debitorCatalogueItemsUpd,
            isDebitorCatalogueError: false,
            isDebitorCatalogueLoaded: true
        });
    },

    resizeDebitorCataloguePage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setDebitorCataloguePageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractDebitorCatalogue: () => async (dispatch, state) => {
        const { Headers } = state().debitorCatalogue.debitorCatalogueItems;
        const { debitorCatalogueColSort, debitorCatalogueIsSortedAsc, debitorCatalogueTableFilterList, debitorCatalogueTableFilterApply } = state().debitorCatalogue;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Debitor Extract – ${formattedTimeZoneDate}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: debitorCatalogueColSort,
            IsSortAscending: debitorCatalogueIsSortedAsc,
            TableFilterList: debitorCatalogueTableFilterList,
            ApplyFilter: debitorCatalogueTableFilterApply,

        };

        httpDownload('external/recharge/getAllDebitorCatalogueExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    saveDebitorCatalogueCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().debitorCatalogue.debitorCatalogueItems;
        const { debitorCatalogueColSort, debitorCatalogueIsSortedAsc } = state().debitorCatalogue;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.DebitorCatalogueRechargeManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/recharge/saveDebitorCatalogueCustomizeColumns', customizeFormData)
            dispatch({
                type: setDebitorCatalogueError,
                isDebitorCatalogueError: false,
                isDebitorCatalogueLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: debitorCatalogueColSort,
                IsSortAscending: debitorCatalogueIsSortedAsc
            };

            var debitorCatalogueItems = await httpPost('external/recharge/getDebitorCatalogueItems', data);

            if (debitorCatalogueItems?.Data?.Items?.length) {
                debitorCatalogueItems.Data.Items = debitorCatalogueItems.Data.Items.map(item => {
                    item.VatApplied = item.VatApplied != null
                        ? Number(item.VatApplied).toFixed(2)  // formats to string like "0.00"
                        : "0.00"; // fallback for null
            
                    return item;
                });
            }

            dispatch({
                type: getDebitorCatalogue,
                debitorCatalogueItems: Object.keys(debitorCatalogueItems).length > 0 ? debitorCatalogueItems : DEFAULT_TABLE_RESULT_MODEL,
                isDebitorCatalogueLoaded: true,
                isDebitorCatalogueError: false
            });
        }
        catch (e) {
            dispatch({
                type: setDebitorCatalogueError,
                isDebitorCatalogueError: true,
                isDebitorCatalogueLoaded: false
            });
        }
    },

    addDebitorCatalogueFilter: (tableFilter) => (dispatch, state) => {
        const { debitorCatalogueTableFilterList } = state().debitorCatalogue;
        var filterList = [...debitorCatalogueTableFilterList, tableFilter];
        dispatch({
            type: setDebitorCatalogueFilter,
            filterList: filterList
        })
    },

    removeDebitorCatalogueFilter: (removeIndex) => (dispatch, state) => {
        const { debitorCatalogueTableFilterList } = state().debitorCatalogue;
        var filterList = debitorCatalogueTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });
        dispatch({
            type: setDebitorCatalogueFilter,
            filterList: filterList
        })
    },

    applyDebitorCatalogueFilter: (isApply) => (dispatch, state) => {
        const { debitorCatalogueTableFilterList } = state().debitorCatalogue;
        dispatch({
            type: applyDebitorCatalogueFilter,
            applyFilter: isApply,
            filterList: isApply ? debitorCatalogueTableFilterList : []
        });
    },

    fetchCountryListSuggestions: (searchVal, propsName) => async (dispatch, state) => {
        var res = await httpPost('external/autosuggest/getRechargeDebitorCountrySuggestions/' + searchVal);
        
        if (res && res.length > 0) {
            dispatch({ type: setDebitorCountryList, data: res });
            return res;
        } 
        else {
            dispatch({ type: setDebitorCountryList, data: [] });
            return null;
        }
    },

    getCountryCode: (countryId) => async (dispatch, state) => {
        var res = await httpGet('external/recharge/getCountryCode' + '/' + countryId);
        if (res != "") {
            dispatch(actions.change('debitorCatalogueForm.countryCode', res));
        }
        else {
            dispatch({
                type: setDebitorCatalogueError,
                isDebitorCatalogueError: true
            });
        }
    },

    getSalesOrganizationDetails: (salesOrganizationId) => async (dispatch, state) => {
        var res = await httpGet('external/recharge/getSalesOrganizationDetails' + '/' + salesOrganizationId);

        if (res != null) {
            dispatch(actions.change('debitorCatalogueForm.salesOrganizationName', res.SalesOrganizationName));
            dispatch(actions.change('debitorCatalogueForm.salesOrganizationCountryCode', res.SalesOrganizationCountryCode));
        }
        else {
            dispatch({
                type: setDebitorCatalogueError,
                isDebitorCatalogueError: true
            });
        }
    },

    getDebitorCatalogueDropdownList: () => async (dispatch, state) => {
        var res = await httpGet('external/recharge/getDebitorCatalogueDropdownList');

        if (res != null) {
            dispatch({
                type: getDebitorCatalogueDropdownList,
                isDebitorCatalogueDropDownListLoaded: true,
                debitorCatalogueDropDownList: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_DEBITOR_CATALOGUE_DROPDOWN_MODEL,
            });
        }
        else {
            dispatch({
                type: setDebitorCatalogueError,
                isDebitorCatalogueDropDownListLoaded: false,
                isDebitorCatalogueError: true
            });
        }
    },

    getCountriesList: (page=1, searchString='') => async (dispatch, getState) => {
    
            if (getState().isDebitorCountryLoaded) return;
    
            const pageSize = 15;
    
            dispatch({ 
                type: getDebitorCountryList,
                isDebitorCountryLoaded: false 
            });
                    
            var url = `external/recharge/getDebitorCountryList/${page}/${pageSize}`;
    
            if(searchString) {
                url += `/${encodeURIComponent(searchString)}`;
            }
            
            var res = await httpGet(url);
    
            if (res != null) {
                dispatch({
                    type: getDebitorCountryList,
                    isDebitorCountryLoaded: true,
                    countryList: res?.countries?.length > 0 ? res?.countries : [],
                    hasMoreData: res.hasMoreData,
                    page: page,
                });
            }
            else {
                dispatch({
                    type: getDebitorCountryList,
                    isDebitorCountryLoaded: false,
                    countryList: [],
                    isError: true
                });
            }
    },

     getDebitorSalesOrganizationList: (page=1, searchString='') => async (dispatch, getState) => {
    
        if (getState().isDebitorSalesOrganizationListLoaded) return;

        const pageSize = 15;

        dispatch({ 
            type: getDebitorSalesOrganizationList,
            isDebitorSalesOrganizationListLoaded: false 
        });
                
        var url = `external/recharge/getArticleSalesOrgNumberList/${page}/${pageSize}`;

        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        
        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getDebitorSalesOrganizationList,
                isDebitorSalesOrganizationListLoaded: true,
                salesOrganizationList: res?.orgNumbers?.length > 0 ? res?.orgNumbers : [],
                hasMoreData: res.hasMoreData,
                page: page,
            });
        }
        else {
            dispatch({
                type: getDebitorSalesOrganizationList,
                isDebitorSalesOrganizationListLoaded: false,
                salesOrganizationList: [],
                isError: true
            });
        }
    },

    getSelectedSalesOrg: (salesOrganizationId) => async (dispatch) => {
        var res = await httpGet('external/recharge/getSelectedSalesOrg' + '/' + salesOrganizationId);
        return res;
    },

    getDebitorCatalogueForm: (debitorCatalogueDetails) => async (dispatch, state) => {
        if (debitorCatalogueDetails) {
            var debitorId = debitorCatalogueDetails.DebitorId;
            var res = await httpGet(`external/recharge/getDebitorDetails/${debitorId}`);
        }
        const { debitorCatalogueDropDownList } = state().debitorCatalogue;
        var initialDebitorCatalogueDetail = JSON.parse(JSON.stringify(initialState.debitorCatalogueDetails));
        setDebitorCatalogueForm(dispatch, debitorCatalogueDropDownList, initialDebitorCatalogueDetail, debitorCatalogueDetails, res)
    },
   
    saveDebitorCatalogueForm: (debitorId, validate) => async (dispatch, state) =>{ 

        try{
            const { debitorCatalogueForm } = state().form;
            const { debitorId, debitorNumber, debitorName, oeName, countryId,
                    currencyId, salesOrganizationId, vatGroupId, vatPercent} = debitorCatalogueForm;

            const formData = {
                ...debitorCatalogueForm,
                debitorId: debitorId,
                debitorNumber: debitorNumber,
                debitorName: debitorName,
                oeName: oeName,
                countryId: countryId,
                currencyId: currencyId,
                salesOrganizationId: salesOrganizationId,
                vatGroupId: vatGroupId,
                vatPercent: vatPercent
            }

            var result = await saveDebitorCatalogue(debitorId, validate, formData);

            if (result.success && validate == false){
                dispatch(actions.load("debitorCatalogueForm", debitorCatalogueForm))
            }

            return result
        }
        catch (e){
            return e;
        }
    },

    resetDebitorCatalogueForm: () => async (dispatch) =>{
        dispatch(actions.reset('debitorCatalogueForm'));

        dispatch({
            type: resetDebitorCatalogueForm,
            isFetchFormLoaded: false,
            isDebitorCatalogueError: false,
        });
    }
};

function setDebitorCatalogueForm(dispatch, debitorCatalogueDropDownList, initialDebitorCatalogueDetail, debitorCatalogueDetails, data){
    var debitorDetails = JSON.parse(JSON.stringify(initialDebitorCatalogueDetail));

    if (debitorCatalogueDetails){
        debitorDetails.debitorId = data.DebitorId;
        debitorDetails.debitorNumber = data.DebitorNumber;
        debitorDetails.debitorName = data.DebitorName;
        debitorDetails.oeName = data.OEName;
        debitorDetails.countryId = data.CountryID;
        debitorDetails.currencyId = data.CurrencyID;
        debitorDetails.salesOrganizationId = data.SalesOrganizationID;
        debitorDetails.salesOrganizationName = data.SalesOrganizationName;
        debitorDetails.salesOrganizationCountryCode = data.SalesOrganizationCountryCode;
        debitorDetails.vatPercent = data.VatPercent;
        debitorDetails.vatGroupId = data.VatGroupID;
        debitorDetails.countryCode = data.CountryCode;
    }
    var initialVatGroup = !debitorCatalogueDetails && debitorCatalogueDetails?.vatGroupId !== 0 ? 2 : debitorDetails?.vatGroupId;

    dispatch(actions.reset('debitorCatalogueForm'));
    dispatch(actions.load('debitorCatalogueForm.debitorId', debitorDetails.debitorId))
    dispatch(actions.load('debitorCatalogueForm.debitorNumber', debitorDetails.debitorNumber));
    dispatch(actions.load('debitorCatalogueForm.debitorName', debitorDetails.debitorName));
    dispatch(actions.load('debitorCatalogueForm.oeName', debitorDetails.oeName));
    dispatch(actions.load('debitorCatalogueForm.countryId', debitorDetails.countryId));
    dispatch(actions.load('debitorCatalogueForm.countryCode', debitorDetails.countryCode));
    dispatch(actions.load('debitorCatalogueForm.currencyId', debitorDetails.currencyId));
    dispatch(actions.load('debitorCatalogueForm.salesOrganizationId', debitorDetails.salesOrganizationId));
    dispatch(actions.load('debitorCatalogueForm.salesOrganizationName', debitorDetails.salesOrganizationName));
    dispatch(actions.load('debitorCatalogueForm.salesOrganizationCountryCode', debitorDetails.salesOrganizationCountryCode));
    dispatch(actions.load('debitorCatalogueForm.vatPercent', debitorDetails.vatPercent));
    dispatch(actions.load('debitorCatalogueForm.vatGroupId', initialVatGroup));
    dispatch({
        type: getDebitorDetailbyId,
        debitorDetails: debitorDetails,
        isFetchFormLoaded: true,
        isDebitorCatalogueError: false,
    });
}

async function saveDebitorCatalogue(debitorId, validate, data){
    try{
        var result = await httpPost(`external/recharge/saveDebitorDetails/${debitorId ?? 0}/${validate ?? 0}`, data)

        if (result.ok == false){
            throw {
                success: false,
                message: "Debitor details is not saved. Error encouterd while on saving"
            }
        }
        return result
    }
    catch(e){
        throw e;
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getDebitorCatalogue:
            return {
                ...state,
                debitorCatalogueItems: action.debitorCatalogueItems,
                isDebitorCatalogueLoaded: action.isDebitorCatalogueLoaded,
                isDebitorCatalogueError: action.isDebitorCatalogueError
            };
        case setDebitorCatalogueColSearchStr:
            return {
                ...state,
                debitorCatalogueItems: action.data,
                isDebitorCatalogueLoaded: action.isDebitorCatalogueLoaded,
                isDebitorCatalogueError: action.isDebitorCatalogueError
            };
        case sortDebitorCatalogueItems:
            return {
                ...state,
                debitorCatalogueItems: action.debitorCatalogueItems,
                debitorCatalogueColSort: action.debitorCatalogueColSort,
                debitorCatalogueIsSortedAsc: action.debitorCatalogueIsSortedAsc,
                isDebitorCatalogueLoaded: action.isDebitorCatalogueLoaded
            };
        case setDebitorCataloguePageSize:
            return {
                ...state,
                debitorCatalogueItems: {
                    ...state.debitorCatalogueItems,
                    Pagination: {
                        ...state.debitorCatalogueItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };
        case setDebitorCatalogueFilter:
            return {
                ...state,
                debitorCatalogueTableFilterList: action.filterList
            };
        case applyDebitorCatalogueFilter:
            return {
                ...state,
                debitorCatalogueTableFilterApply: action.applyFilter,
                debitorCatalogueTableFilterList: action.filterList
            }
        case getDebitorDetailbyId:
            return{
                ...state,
                debitorCatalogueDetails: action.debitorDetails,
                debitorDetails: action.debitorDetails,
                isDebitorCatalogueError: action.isDebitorCatalogueError,
                isFetchFormLoaded: action.isFetchFormLoaded,
            };
        case getDebitorCatalogueDropdownList:
            return {
                ...state,
                isDebitorCatalogueDropDownListLoaded: action.isDebitorCatalogueDropDownListLoaded,
                debitorCatalogueDropDownList: action.debitorCatalogueDropDownList
            };
        case setDebitorCatalogueError:
            return {
                ...state,
                isDebitorCatalogueError: action.isDebitorCatalogueError,
                isDebitorCatalogueLoaded: action.isDebitorCatalogueLoaded
            };
        case resetDebitorCatalogueForm:
            return{
                ...state,
                isFetchFormLoaded: action.isFetchFormLoaded,
                isDebitorCatalogueError: action.isDebitorCatalogueError
            };
        case setDebitorCountryList: 
            return{
                ...state,
                countryList: action.data
            };
        case getDebitorCountryList:
              return {
                ...state,
                countryList: action.page === 1? action.countryList ?? [] : [...state.countryList, ...action.countryList ?? []],
                hasMoreCountries: action.hasMoreData,
                isDebitorCountryLoaded: action.isDebitorCountryLoaded,
                countriesListPage: action.page
            }
        case getDebitorSalesOrganizationList:
                return {
                ...state,
                salesOrganizationList: action.page === 1? action?.salesOrganizationList ?? [] : [...state?.salesOrganizationList, ...action?.salesOrganizationList ?? []],
                hasMoreSalesOrgList: action.hasMoreData,
                isDebitorSalesOrganizationListLoaded: action.isDebitorSalesOrganizationListLoaded,
                salesOrganizationPage: action.page
            }
        case setDefaultDebitorCatalogue:
            return initialState;
        default:
            return state;
    }
};